<div class="card">
  <div class="card-body">
    <div class="mb-3">
      <h2 class="h4 card-title d-inline">Data Export Downloads</h2>
      <button type="button" class="btn btn-sm btn-success d-inline mx-3" (click)="refreshExports.emit()">Refresh grid</button>
    </div>
    <p-table [value]="exports" [columns]="cols" [rows]="rows" [paginator]="true" [alwaysShowPaginator]="false"  [autoLayout]="true" responsiveLayout="scroll">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngFor="let col of columns">
            {{ col.header }}
          </th>
          <th scope="col">Download link</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-result>
        <tr>
          <th scope="row">{{ result.ExportTypeName }}</th>
          <td>{{ result.CrimeGunNumber}}</td>
          <td>{{ result.Status | exportStatusTransform }}</td>
          <td>{{ result.GeneratedOn | date:'MM/dd/yyyy  HH:mm'}}</td>
          <td>{{ result.ExpiresOn | date:'MM/dd/yyyy  HH:mm'}}</td>
          <td>
            <button *ngIf="result.Status === 'Completed' && !result.Message;else message" class="btn btn-link" aria-label="Download export .csv file" (click)="downloadExport(result)">{{ generateCSVFilename(result)}}</button>
          </td>
          <ng-template #message>
            <ng-container *ngIf="(result.Status === 'Completed' || result.Status === 'Delay') && !!result.Message">{{ result.Message }}</ng-container>
          </ng-template>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 1">
            No export downloads found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
